export default "__VITE_ASSET__kCooMcct__"